/**
 * Dummy data — 차량 관리 (관리자)
 * API_DOCS: 22. 관리자 - 차량
 *
 * VehicleResponse:
 *   id(int), name(string?), vehicle_type(string?), plate_number(string?),
 *   max_passengers(int?), description(string?), is_active(boolean), created_at(datetime)
 */

const vehicles = [
  {
    id: 1,
    name: '2026 스타리아 라운지',
    vehicle_type: 'van',
    plate_number: '100라 6000',
    max_passengers: 6,
    description: '최고급 프리미엄 밴',
    is_active: true,
    created_at: '2026-01-01T00:00:00',
  },
  {
    id: 2,
    name: '2026 스타리아 라운지 블랙',
    vehicle_type: 'van',
    plate_number: '200가 7000',
    max_passengers: 6,
    description: '블랙 에디션 프리미엄 밴',
    is_active: true,
    created_at: '2026-01-15T00:00:00',
  },
  {
    id: 3,
    name: '2025 제네시스 G80',
    vehicle_type: 'sedan',
    plate_number: '300나 8000',
    max_passengers: 3,
    description: 'VIP 세단 (정비 중)',
    is_active: false,
    created_at: '2026-02-01T00:00:00',
  },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/admin/vehicles — 차량 목록 (페이지네이션) */
export const getVehicles = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: vehicles.slice(start, start + size),
    total: vehicles.length,
    page,
    size,
    pages: Math.ceil(vehicles.length / size),
  };
};

/** GET /api/admin/vehicles/:id */
export const getVehicleById = async (id) => {
  await delay(200);
  const found = vehicles.find((v) => v.id === Number(id));
  if (!found) throw new Error('차량을 찾을 수 없습니다');
  return found;
};

/** POST /api/admin/vehicles */
export const createVehicle = async (data) => {
  await delay(400);
  const newVehicle = {
    id: vehicles.length + 1,
    name: data.name || null,
    vehicle_type: data.vehicle_type || null,
    plate_number: data.plate_number || null,
    max_passengers: data.max_passengers || null,
    description: data.description || null,
    is_active: data.is_active !== undefined ? data.is_active : true,
    created_at: new Date().toISOString(),
  };
  vehicles.push(newVehicle);
  return newVehicle;
};

/** PUT /api/admin/vehicles/:id */
export const updateVehicle = async (id, data) => {
  await delay(400);
  const idx = vehicles.findIndex((v) => v.id === Number(id));
  if (idx === -1) throw new Error('차량을 찾을 수 없습니다');
  vehicles[idx] = { ...vehicles[idx], ...data };
  return vehicles[idx];
};

/** DELETE /api/admin/vehicles/:id */
export const deleteVehicle = async (id) => {
  await delay(300);
  const idx = vehicles.findIndex((v) => v.id === Number(id));
  if (idx === -1) throw new Error('차량을 찾을 수 없습니다');
  vehicles.splice(idx, 1);
  return { message: '차량이 삭제되었습니다' };
};
